const v12 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        videosTable: {
          ...state.options.tableViews.videosTable,
          Rec7: false,
          Rec30: false,
          ARP7: false,
          ARP30: false,
        },
        topScriptTopicsTable: {
          ...state.options.tableViews.topScriptTopicsTable,
          Rec7: false,
          Rec30: false,
          ARP7: false,
          ARP30: false,
        },
        topThumbTopicsTable: {
          ...state.options.tableViews.topThumbTopicsTable,
          Rec7: false,
          Rec30: false,
          ARP7: false,
          ARP30: false,
        },
        topTitleTopicsTable: {
          ...state.options.tableViews.topTitleTopicsTable,
          Rec7: false,
          Rec30: false,
          ARP7: false,
          ARP30: false,
        },
        topVideoTypesTable: {
          ...state.options.tableViews.topVideoTypesTable,
          Rec7: false,
          Rec30: false,
          ARP7: false,
          ARP30: false,
        },
      },
    },
  };
};

export default v12;
